import { render, staticRenderFns } from "./messageListView.vue?vue&type=template&id=508e2d14&scoped=true&"
import script from "./messageListView.vue?vue&type=script&lang=js&"
export * from "./messageListView.vue?vue&type=script&lang=js&"
import style0 from "./messageListView.vue?vue&type=style&index=0&id=508e2d14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e2d14",
  null
  
)

export default component.exports